import { render } from "./TimeSpentToggle.vue?vue&type=template&id=06e5f3d6"
import script from "./TimeSpentToggle.vue?vue&type=script&lang=js"
export * from "./TimeSpentToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__